module.exports = __webpack_public_path__ + "static/media/solarpak.543ac221.jpg";